import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  // App is permanently dark-themed; hardcode so toasts never render light
  // (next-themes defaults to "system" → white toasts on the black UI).
  const resolved = "dark"

  return (
    <Sonner
      theme={resolved}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#121316] group-[.toaster]:text-[#ecebe4] group-[.toaster]:border-[#22242a] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[#8e929b]",
          actionButton:
            "group-[.toast]:bg-[#39ff14] group-[.toast]:text-black",
          cancelButton:
            "group-[.toast]:bg-[#22242a] group-[.toast]:text-[#ecebe4]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
